import { defineMessages } from 'react-intl';

/** The copy of the Releases list (Releases v2, design a1–a3). */
export const releaseListMessages = defineMessages({
  subtitle: {
    id: 'app.sml.releases.list.subtitle',
    defaultMessage:
      'Every song in your catalog. Open one to see what you did, what is planned, and what you can still make.',
  },
  find: { id: 'app.sml.releases.list.find', defaultMessage: 'Find a song' },
  openStudio: { id: 'app.sml.releases.list.openStudio', defaultMessage: 'Open Studio' },
  open: { id: 'app.sml.releases.list.open', defaultMessage: 'Open' },
  openLabel: { id: 'app.sml.releases.list.openLabel', defaultMessage: 'Open {title}' },
  draft: { id: 'app.sml.releases.list.draft', defaultMessage: 'Draft' },
  finishSetup: { id: 'app.sml.releases.list.finishSetup', defaultMessage: 'Finish setup' },
  finishSetupLabel: { id: 'app.sml.releases.list.finishSetupLabel', defaultMessage: 'Finish setup of {title}' },
  drafts: { id: 'app.sml.releases.list.drafts', defaultMessage: 'Drafts' },
  draftsSub: {
    id: 'app.sml.releases.list.draftsSub',
    defaultMessage: 'songs with only a title · finish the setup to start',
  },
  colSong: { id: 'app.sml.releases.list.col.song', defaultMessage: 'Song' },
  colNext: { id: 'app.sml.releases.list.col.next', defaultMessage: 'Next step' },
  colAssets: { id: 'app.sml.releases.list.col.assets', defaultMessage: 'Assets' },
  colPosts: { id: 'app.sml.releases.list.col.posts', defaultMessage: 'Posts' },
  colLinks: { id: 'app.sml.releases.list.col.links', defaultMessage: 'Links' },
  upcoming: { id: 'app.sml.releases.list.upcoming', defaultMessage: 'Upcoming' },
  upcomingSub: {
    id: 'app.sml.releases.list.upcomingSub',
    defaultMessage: '{count, plural, one {# song} other {# songs}} · soonest first',
  },
  active: { id: 'app.sml.releases.list.active', defaultMessage: 'Active' },
  activeSub: {
    id: 'app.sml.releases.list.activeSub',
    defaultMessage: 'made, posted or planned in the last 30 days',
  },
  quiet: { id: 'app.sml.releases.list.quiet', defaultMessage: 'Quiet' },
  quietSub: { id: 'app.sml.releases.list.quietSub', defaultMessage: 'no activity in the last 30 days' },
  quietCount: {
    id: 'app.sml.releases.list.quietCount',
    defaultMessage: '{count, plural, one {# quiet song} other {# quiet songs}}',
  },
  quietSongs: {
    id: 'app.sml.releases.list.quietSongs',
    defaultMessage: '{count, plural, one {# song} other {# songs}}',
  },
  show: { id: 'app.sml.releases.list.show', defaultMessage: 'Show' },
  hide: { id: 'app.sml.releases.list.hide', defaultMessage: 'Hide' },
  assets: { id: 'app.sml.releases.list.assets', defaultMessage: 'assets' },
  newCount: { id: 'app.sml.releases.list.newCount', defaultMessage: '{count} new' },
  donePlanned: { id: 'app.sml.releases.list.donePlanned', defaultMessage: 'done · planned' },
  smartLink: { id: 'app.sml.releases.list.smartLink', defaultMessage: 'SmartLink' },
  noSmartLink: { id: 'app.sml.releases.list.noSmartLink', defaultMessage: 'No SmartLink' },
  presave: { id: 'app.sml.releases.list.presave', defaultMessage: 'Pre-save' },
  presaveEnded: { id: 'app.sml.releases.list.presaveEnded', defaultMessage: 'Pre-save ended' },
  noPresave: { id: 'app.sml.releases.list.noPresave', defaultMessage: 'No pre-save' },
  quietLine: {
    id: 'app.sml.releases.list.quietLine',
    defaultMessage:
      '{when} · {assets, plural, one {# asset} other {# assets}} · {posts, plural, one {# post} other {# posts}}',
  },
  emptyTitle: { id: 'app.sml.releases.list.empty.title', defaultMessage: 'Add a song to your catalog first.' },
  emptyBody: {
    id: 'app.sml.releases.list.empty.body',
    defaultMessage: 'Each song in your catalog is a release. Its assets, posts and links show up here.',
  },
  emptyAdd: { id: 'app.sml.releases.list.empty.add', defaultMessage: 'Add a song' },
  noMatch: { id: 'app.sml.releases.list.noMatch', defaultMessage: 'No song matches "{query}".' },
});
